export const tr = {
    cancel: 'İptal',
    stop: 'Durdur',
    'stop-active-brand-lift-for-campaigns': 'Brand Lift çalışması şu kampanyalarda yapılıyor:',
    'stop-active-brand-lift-for-campaigns-helper':
        'Bu kampanyaları süresinden önce durdurmayın. Toplanmış veriler güvenilir sonuçlar için yeterli olmayabilir.'
};
